<ng-container [formGroup]="formGroup">
  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.bostonPizzaUIControlMusicUrl' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="controlMusicUrl">
    <mat-error *ngIf="formGroup.get('controlMusicUrl')?.errors?.pattern && formGroup.get('controlMusicUrl')?.touched">
      {{ 'pages.restaurantAccount.urlValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.bostonPizzaUIGoogleReviewsUrl' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="googleReviewsUrl">
    <mat-error *ngIf="formGroup.get('googleReviewsUrl')?.errors?.pattern && formGroup.get('googleReviewsUrl')?.touched">
      {{ 'pages.restaurantAccount.urlValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.bostonPizzaUIGuestSurveyUrl' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="guestSurveyUrl">
    <mat-error *ngIf="formGroup.get('guestSurveyUrl')?.errors?.pattern && formGroup.get('guestSurveyUrl')?.touched">
      {{ 'pages.restaurantAccount.urlValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <div class="checkbox-group">
    <mat-checkbox color="primary" formControlName="notAcceptingRewardsCardsDisclaimer">
      <span class="checkbox-label">{{ 'pages.restaurantAccount.bostonPizzaUINotAcceptingRewardsCardsDisclaimer' | translate }}</span>
    </mat-checkbox>

    <mat-checkbox color="primary" formControlName="happyHourPilot">
      <span class="checkbox-label">{{ 'pages.restaurantAccount.bostonPizzaUIHappyHourPilot' | translate }}</span>
    </mat-checkbox>

    <mat-checkbox color="primary" formControlName="interacBanner">
      <span class="checkbox-label">{{ 'pages.restaurantAccount.bostonPizzaUIInteracBanner' | translate }}</span>
    </mat-checkbox>
  </div>
</ng-container>
